export default __webpack_public_path__ + "static/hero-plasma-6415eeddc74e53fe3ce9b5df3abd2dde.jpg";